import { Paper, Text, Group, createStyles, Box, LoadingOverlay } from '@mantine/core';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useDasboardApi from '../../hooks/useDashboardApi';
import DetailMenu from './card-components/DetailMenu';
import TimeSelector from './card-components/TimeSelector';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';

// Custom styles
const useStyles = createStyles((theme) => ({
	container: {
		padding: '20px 0 10px'
	},
	text: {
		fontSize: 32,
		lineHeight: '38px',
		fontWeight: 400,
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	},
	cardTitle: {
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '20px',
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	}
}));

export default function TotalTime() {

	// State and hooks
	const { classes } = useStyles();
	const [selectedRange, setSelectedRange] = useState('total');
	const [range, setRange] = useState([null, null]);
	const [visible, setVisible] = useState(false);
	const { getTime } = useDasboardApi();
	const totalTime = useSelector(state => state.dashboardData.totalTime);

	// On load
	useEffect(() => {
		async function fetchData() {
			await getTime('', '');
		}
		fetchData();
		// eslint-disable-next-line
	}, []);

	// Listen to selected range changes
	useEffect(() => {

		// Only if initial data has loaded
		if (totalTime !== null) reload();

		// eslint-disable-next-line
	}, [selectedRange]);

	// Reload with new values
	const reload = async () => {

		// Set loader
		setVisible(true);

		// Define date variables
		let endDate = new Date();
		let startDate = new Date();

		// Check date range to apply
		switch (selectedRange) {
			case '30d':
				startDate.setDate(endDate.getDate() - 30);
				break;
			case '7d':
				startDate.setDate(endDate.getDate() - 7);
				break;
			case 'total':
				// Remove both dates
				endDate = '';
				startDate = '';
				break;
			case 'custom':
				// Assign custom range
				endDate = range[1];
				startDate = range[0];
				break;
			default:
				// Remove both dates
				endDate = '';
				startDate = '';
				break;
		}

		// Get information
		if (selectedRange) await getTime(startDate, endDate);

		// Remove loader
		setVisible(false);

	}

	// Convert and download as CSV file
	const convertToCSV = () => {

		// Copy and stringify
		const parsedData = [{
			tiempo: totalTime ? `${totalTime?.years}a ${totalTime?.days}d ${totalTime?.hours}h` : '0a 0d 0h',
		}];

		// Parse and convert to CSV
		const csv = Papa.unparse(parsedData, { header: true });

		// Generate file
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

		// Save file
		saveAs(blob, 'tiempo.csv');

	};

	return (
		<Paper
			withBorder
			p={12}
			style={{ position: 'relative' }}
			radius={18}
		>
			{/* Loading Overlay */}
			<LoadingOverlay
				visible={visible}
				overlayBlur={1}
				radius={18}
			/>
			{/* Top */}
			<Group
				position="apart"
				noWrap
			>
				{/* Title */}
				<Text className={classes.cardTitle}>
					Tiempo en Bici
				</Text>
				{/* Menu */}
				<DetailMenu onClick={() => convertToCSV()} />
			</Group>
			{/* Time & Filter */}
			<Group
				position="apart"
				mt={8}
				noWrap
				align="center"
			>
				{/* Range */}
				<TimeSelector
					data={totalTime}
					selectedRange={selectedRange}
					setSelectedRange={setSelectedRange}
					range={range}
					setRange={setRange}
				/>
			</Group>
			{/* Content */}
			<Box className={classes.container}>
				<Text className={classes.text}>
					{totalTime ? new Intl.NumberFormat('es-AR', { notation: 'compact' }).format(totalTime?.years * 365 * 24 + totalTime?.days * 24 + totalTime?.hours).replace(/\s(?=K|k|M|B|T)/, '') : '0'} hs
				</Text>
			</Box>
		</Paper>
	);

}
